var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _rect5, _rect6, _circle, _rect7, _rect8, _circle2, _rect9, _rect0, _circle3, _rect1, _rect10, _circle4, _rect11, _rect12, _circle5, _rect13, _rect14, _circle6, _rect15, _rect16, _circle7, _rect17, _rect18, _circle8, _rect19, _rect20, _rect21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasteLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 870,
    height: 686,
    viewBox: "0 0 975 686",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 841,
    y: 646,
    width: 134,
    height: 40,
    rx: 4,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M749.094 663.42C749.033 662.883 748.783 662.466 748.344 662.17C747.904 661.871 747.351 661.722 746.685 661.722C746.207 661.722 745.795 661.797 745.446 661.949C745.098 662.097 744.827 662.301 744.634 662.562C744.444 662.82 744.349 663.114 744.349 663.443C744.349 663.72 744.414 663.958 744.543 664.159C744.675 664.36 744.848 664.528 745.06 664.665C745.276 664.797 745.507 664.909 745.753 665C745.999 665.087 746.236 665.159 746.463 665.216L747.599 665.511C747.971 665.602 748.351 665.725 748.741 665.881C749.132 666.036 749.493 666.241 749.827 666.494C750.16 666.748 750.429 667.062 750.634 667.438C750.842 667.812 750.946 668.261 750.946 668.784C750.946 669.443 750.776 670.028 750.435 670.54C750.098 671.051 749.607 671.455 748.963 671.75C748.323 672.045 747.548 672.193 746.639 672.193C745.768 672.193 745.014 672.055 744.378 671.778C743.741 671.502 743.243 671.11 742.884 670.602C742.524 670.091 742.325 669.485 742.287 668.784H744.048C744.082 669.205 744.219 669.555 744.457 669.835C744.7 670.112 745.009 670.318 745.384 670.455C745.762 670.587 746.177 670.653 746.628 670.653C747.124 670.653 747.565 670.576 747.952 670.42C748.342 670.261 748.649 670.042 748.872 669.761C749.096 669.477 749.207 669.146 749.207 668.767C749.207 668.422 749.109 668.14 748.912 667.92C748.719 667.701 748.455 667.519 748.122 667.375C747.793 667.231 747.42 667.104 747.003 666.994L745.628 666.619C744.696 666.366 743.957 665.992 743.412 665.5C742.87 665.008 742.599 664.356 742.599 663.545C742.599 662.875 742.781 662.29 743.145 661.79C743.509 661.29 744.001 660.902 744.622 660.625C745.243 660.345 745.944 660.205 746.724 660.205C747.512 660.205 748.207 660.343 748.81 660.619C749.416 660.896 749.893 661.277 750.241 661.761C750.59 662.242 750.772 662.795 750.787 663.42H749.094ZM754.47 669.04L754.459 666.966H754.754L758.232 663.273H760.266L756.3 667.477H756.033L754.47 669.04ZM752.908 672V660.364H754.607V672H752.908ZM758.419 672L755.294 667.852L756.464 666.665L760.504 672H758.419ZM761.814 672V663.273H763.513V672H761.814ZM762.672 661.926C762.376 661.926 762.123 661.828 761.911 661.631C761.702 661.43 761.598 661.191 761.598 660.915C761.598 660.634 761.702 660.396 761.911 660.199C762.123 659.998 762.376 659.898 762.672 659.898C762.967 659.898 763.219 659.998 763.428 660.199C763.64 660.396 763.746 660.634 763.746 660.915C763.746 661.191 763.64 661.43 763.428 661.631C763.219 661.828 762.967 661.926 762.672 661.926ZM765.798 675.273V663.273H767.457V664.688H767.599C767.698 664.506 767.84 664.295 768.026 664.057C768.211 663.818 768.469 663.61 768.798 663.432C769.128 663.25 769.563 663.159 770.105 663.159C770.81 663.159 771.438 663.337 771.991 663.693C772.545 664.049 772.978 664.562 773.293 665.233C773.611 665.903 773.77 666.71 773.77 667.653C773.77 668.597 773.613 669.405 773.298 670.08C772.984 670.75 772.552 671.267 772.003 671.631C771.454 671.991 770.827 672.17 770.122 672.17C769.592 672.17 769.158 672.081 768.821 671.903C768.488 671.725 768.226 671.517 768.037 671.278C767.848 671.04 767.702 670.828 767.599 670.642H767.497V675.273H765.798ZM767.463 667.636C767.463 668.25 767.552 668.788 767.73 669.25C767.908 669.712 768.166 670.074 768.503 670.335C768.84 670.593 769.253 670.722 769.741 670.722C770.249 670.722 770.673 670.587 771.014 670.318C771.355 670.045 771.613 669.676 771.787 669.21C771.965 668.744 772.054 668.22 772.054 667.636C772.054 667.061 771.967 666.544 771.793 666.085C771.622 665.627 771.365 665.265 771.02 665C770.679 664.735 770.253 664.602 769.741 664.602C769.249 664.602 768.832 664.729 768.491 664.983C768.154 665.237 767.899 665.591 767.724 666.045C767.55 666.5 767.463 667.03 767.463 667.636Z",
    fill: "#111827"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 654,
    width: 224,
    height: 16,
    fill: "#F3F4F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 660,
    width: 94,
    height: 16,
    fill: "#F3F4F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 544,
    width: 224,
    height: 16,
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 266H87.6278V254.364H91.3778C92.5066 254.364 93.4725 254.597 94.2756 255.062C95.0786 255.525 95.6941 256.189 96.1222 257.057C96.5502 257.92 96.7642 258.955 96.7642 260.159C96.7642 261.371 96.5483 262.415 96.1165 263.29C95.6847 264.161 95.0559 264.831 94.2301 265.301C93.4044 265.767 92.4006 266 91.2188 266ZM89.0369 264.75H91.1278C92.09 264.75 92.8873 264.564 93.5199 264.193C94.1525 263.822 94.6241 263.294 94.9347 262.608C95.2453 261.922 95.4006 261.106 95.4006 260.159C95.4006 259.22 95.2472 258.411 94.9403 257.733C94.6335 257.051 94.1752 256.528 93.5653 256.165C92.9555 255.797 92.196 255.614 91.2869 255.614H89.0369V264.75ZM98.946 266V257.273H100.287V266H98.946ZM99.6278 255.818C99.3665 255.818 99.1411 255.729 98.9517 255.551C98.7661 255.373 98.6733 255.159 98.6733 254.909C98.6733 254.659 98.7661 254.445 98.9517 254.267C99.1411 254.089 99.3665 254 99.6278 254C99.8892 254 100.113 254.089 100.298 254.267C100.488 254.445 100.582 254.659 100.582 254.909C100.582 255.159 100.488 255.373 100.298 255.551C100.113 255.729 99.8892 255.818 99.6278 255.818ZM104.084 260.75V266H102.743V257.273H104.038V258.636H104.152C104.357 258.193 104.667 257.837 105.084 257.568C105.5 257.295 106.038 257.159 106.697 257.159C107.288 257.159 107.805 257.28 108.249 257.523C108.692 257.761 109.036 258.125 109.283 258.614C109.529 259.098 109.652 259.712 109.652 260.455V266H108.311V260.545C108.311 259.86 108.133 259.326 107.777 258.943C107.421 258.557 106.932 258.364 106.311 258.364C105.883 258.364 105.5 258.456 105.163 258.642C104.83 258.828 104.567 259.098 104.374 259.455C104.18 259.811 104.084 260.242 104.084 260.75ZM112.102 266V257.273H113.443V266H112.102ZM112.784 255.818C112.523 255.818 112.297 255.729 112.108 255.551C111.922 255.373 111.83 255.159 111.83 254.909C111.83 254.659 111.922 254.445 112.108 254.267C112.297 254.089 112.523 254 112.784 254C113.045 254 113.269 254.089 113.455 254.267C113.644 254.445 113.739 254.659 113.739 254.909C113.739 255.159 113.644 255.373 113.455 255.551C113.269 255.729 113.045 255.818 112.784 255.818ZM117.24 260.75V266H115.899V257.273H117.195V258.636H117.308C117.513 258.193 117.823 257.837 118.24 257.568C118.657 257.295 119.195 257.159 119.854 257.159C120.445 257.159 120.962 257.28 121.405 257.523C121.848 257.761 122.193 258.125 122.439 258.614C122.685 259.098 122.808 259.712 122.808 260.455V266H121.467V260.545C121.467 259.86 121.289 259.326 120.933 258.943C120.577 258.557 120.089 258.364 119.467 258.364C119.039 258.364 118.657 258.456 118.32 258.642C117.986 258.828 117.723 259.098 117.53 259.455C117.337 259.811 117.24 260.242 117.24 260.75ZM128.781 269.455C128.134 269.455 127.577 269.371 127.111 269.205C126.645 269.042 126.257 268.826 125.946 268.557C125.639 268.292 125.395 268.008 125.213 267.705L126.281 266.955C126.402 267.114 126.556 267.295 126.741 267.5C126.927 267.708 127.181 267.888 127.503 268.04C127.829 268.195 128.255 268.273 128.781 268.273C129.486 268.273 130.067 268.102 130.526 267.761C130.984 267.42 131.213 266.886 131.213 266.159V264.386H131.099C131.001 264.545 130.861 264.742 130.679 264.977C130.501 265.208 130.243 265.415 129.906 265.597C129.573 265.775 129.122 265.864 128.554 265.864C127.849 265.864 127.217 265.697 126.656 265.364C126.099 265.03 125.658 264.545 125.332 263.909C125.01 263.273 124.849 262.5 124.849 261.591C124.849 260.697 125.007 259.919 125.321 259.256C125.635 258.589 126.073 258.074 126.634 257.71C127.194 257.343 127.842 257.159 128.577 257.159C129.145 257.159 129.596 257.254 129.929 257.443C130.266 257.629 130.524 257.841 130.702 258.08C130.884 258.314 131.024 258.508 131.122 258.659H131.259V257.273H132.554V266.25C132.554 267 132.384 267.61 132.043 268.08C131.705 268.553 131.251 268.9 130.679 269.119C130.111 269.343 129.478 269.455 128.781 269.455ZM128.736 264.659C129.274 264.659 129.728 264.536 130.099 264.29C130.471 264.044 130.753 263.689 130.946 263.227C131.139 262.765 131.236 262.212 131.236 261.568C131.236 260.939 131.141 260.384 130.952 259.903C130.762 259.422 130.482 259.045 130.111 258.773C129.74 258.5 129.281 258.364 128.736 258.364C128.168 258.364 127.694 258.508 127.315 258.795C126.94 259.083 126.658 259.47 126.469 259.955C126.283 260.439 126.19 260.977 126.19 261.568C126.19 262.174 126.285 262.71 126.474 263.176C126.668 263.638 126.952 264.002 127.327 264.267C127.705 264.528 128.175 264.659 128.736 264.659Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0134 172H90.2622V189.529H88.384L88.0084 172H87.5075L87.1319 189.529H85.2538V172H84.6277C84.2521 175.506 85.379 162.359 83 192.159C83 192.534 83.1252 192.785 83.5008 193.035L86.3807 194.663L85.0034 228.97C85.0034 230.473 86.005 231.85 87.5075 231.975C89.2605 232.226 90.6378 230.849 90.5126 229.221L89.1353 194.663L92.0151 193.035C92.2655 192.91 92.5159 192.534 92.5159 192.159C90.2622 162.359 91.2638 175.506 91.0134 172Z",
    fill: "#374151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.349 172C140.972 172 139.72 173.002 139.595 174.379C138.217 182.267 135.337 200.548 139.469 204.429C139.97 204.805 140.221 205.431 140.221 206.057L139.344 230.222C139.344 231.224 140.095 232.101 141.097 232.101C142.099 232.101 142.975 231.349 142.975 230.222V172.626C143.1 172.376 142.725 172 142.349 172Z",
    fill: "#374151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.801 186.65C105.412 186.65 98.5259 193.537 98.5259 201.926C98.5259 210.315 105.412 217.202 113.801 217.202C122.191 217.202 129.077 210.315 129.077 201.926C129.077 193.537 122.191 186.65 113.801 186.65ZM125.321 203.178C124.569 203.178 124.069 202.677 124.069 201.926C124.069 196.292 119.436 191.659 113.801 191.659C113.05 191.659 112.549 191.158 112.549 190.407C112.549 189.655 113.05 189.155 113.801 189.155C120.813 189.155 126.573 194.914 126.573 201.926C126.573 202.552 125.947 203.178 125.321 203.178Z",
    fill: "#374151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.801 181.641C102.658 181.641 93.6426 190.781 93.6426 201.925C93.6426 213.068 102.658 222.209 113.927 222.209C125.195 222.209 134.211 213.193 134.211 201.925C134.085 190.781 125.07 181.641 113.801 181.641ZM113.801 219.579C104.035 219.579 96.0216 211.566 96.0216 201.799C96.0216 192.033 104.035 184.02 113.801 184.02C123.568 184.02 131.581 192.033 131.581 201.799C131.581 211.566 123.568 219.579 113.801 219.579Z",
    fill: "#374151"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 128,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 253,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 357.5,
    cy: 201.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 489,
    y: 128,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 253,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.5,
    cy: 201.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 128,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 784,
    y: 253,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.5,
    cy: 201.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 128,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 253,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 201.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 334,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 459,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 407.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 489,
    y: 334,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 459,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.5,
    cy: 407.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 334,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 459,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.5,
    cy: 407.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 334,
    width: 224,
    height: 186,
    rx: 16,
    fill: "white",
    stroke: "#E5E7EB"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 784,
    y: 459,
    width: 123,
    height: 18,
    fill: "#F3F4F6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.5,
    cy: 407.5,
    r: 41.5,
    fill: "#F3F4F6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    width: 757,
    height: 22,
    fill: "#F3F4F6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 28,
    width: 294,
    height: 22,
    fill: "#F3F4F6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 66,
    width: 375,
    height: 16,
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteLoader);
export default __webpack_public_path__ + "static/media/taste_loader.a1c473ab2be3c24b66a622a0db1765e8.svg";
export { ForwardRef as ReactComponent };